import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import travelImg from 'images/tmp_travel_image.png'
import styles from './index.module.css'

const TravelDetail8 = () => {

	const App = useApp()
	const [toggleButton, setToggleButton] = useState(false)

	const moreOpen = () => {
		setToggleButton(!toggleButton)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1">
				<div className="img-box" style={{ height: "26rem" }}>
					<img src={travelImg} alt="" />
				</div>
				<div className={styles["travel-guide"]}>
					<div className={`${styles["travel-view"]} shadow`}>
						<div className={`${styles["title-area"]} ${styles.txt}`}>
							<i className="tag tag-box tag-red">여행코스</i>
							<div className={styles.title}>동해바다를 굽어보는 강릉 7번 국도 여행</div>
							<div className={styles["tag-area"]}>
								<span>#중분류</span>
								<span>#소분류</span>
							</div>
							<div className="flex-align_center">
								<div className="flex-align_center" style={{ fontSize: "1.2rem" }}>
									<i className="icon_life icon_life_place icon mr_5" />총 거리 16km
								</div>
								<div className="flex-align_center ml_10" style={{ fontSize: "1.2rem" }}>
									<i className="icon_life icon_life_time icon mr_5" />7시간 소요
								</div>
							</div>
						</div>
					</div>
					<div className="shadow">
						<div className="padding pb_50">
							<div className={styles.content}>
								<p>소개</p>

								{/* 펼쳤을때 open 클래스 제거 */}
								<div className={`${styles.open} mt_10`}>럭셔리 고풍스러운호텔로서의 명성을 이어가고 있는 더 힐
									하우스 호텔은 그 시설뿐만 아니라 고객에 대한 서비스 하
									럭셔리 고풍스러운호텔로서의 명성을 이어가고 있는 더 힐
									하우스 호텔은 그 시설뿐만 아니라 고객에 대한 서비스 하
									럭셔리 고풍스러운호텔로서의 명성을 이어가고 있는 더 힐
									하우스 호텔은 그 시설뿐만 아니라 고객에 대한 서비스 하
									럭셔리 고풍스러운호텔로서의 명성을 이어가고 있는 더 힐
									하우스 호텔은 그 시설뿐만 아니라 고객에 대한 서비스 하
								</div>

								{/* 더보기 접기 */}
								<div className="flex-justify_center mt_30">
									<div className={styles.more} onClick={moreOpen}>더보기 <i className={`${styles.arrow} ${toggleButton ? styles.active : ""}`} /></div>
								</div>
							</div>
						</div>
					</div>

					<div className="padding">
						<div style={{ fontWeight: 500 }}>1코스 : 코스명</div>
						<div className="img-box mt_20" style={{ height: "20rem" }}>
							<img src={travelImg} alt="" />
						</div>
						<div className={styles.content}>
							{/* 펼쳤을때 open 클래스 제거 */}
							<div className={`${styles.open} mt_30`}>럭셔리 고풍스러운호텔로서의 명성을 이어가고 있는 더 힐
								하우스 호텔은 그 시설뿐만 아니라 고객에 대한 서비스 하
								럭셔리 고풍스러운호텔로서의 명성을 이어가고 있는 더 힐
								하우스 호텔은 그 시설뿐만 아니라 고객에 대한 서비스 하
								럭셔리 고풍스러운호텔로서의 명성을 이어가고 있는 더 힐
								하우스 호텔은 그 시설뿐만 아니라 고객에 대한 서비스 하
								럭셔리 고풍스러운호텔로서의 명성을 이어가고 있는 더 힐
								하우스 호텔은 그 시설뿐만 아니라 고객에 대한 서비스 하
							</div>

							{/* 더보기 접기 */}
							<div className="flex-justify_center mt_30">
								<div className={styles.more} onClick={moreOpen}>더보기 <i className={`${styles.arrow} ${toggleButton ? styles.active : ""}`} /></div>
							</div>
						</div>

						<div style={{ fontWeight: 500 }} className="mt_50">2코스 : 불국사</div>
						<div className="img-box mt_20" style={{ height: "20rem" }}>
							<img src={travelImg} alt="" />
						</div>
						<div className={styles.content}>
							{/* 펼쳤을때 open 클래스 제거 */}
							<div className={`${styles.open} mt_30`}>럭셔리 고풍스러운호텔로서의 명성을 이어가고 있는 더 힐
								하우스 호텔은 그 시설뿐만 아니라 고객에 대한 서비스 하
								럭셔리 고풍스러운호텔로서의 명성을 이어가고 있는 더 힐
								하우스 호텔은 그 시설뿐만 아니라 고객에 대한 서비스 하
								럭셔리 고풍스러운호텔로서의 명성을 이어가고 있는 더 힐
								하우스 호텔은 그 시설뿐만 아니라 고객에 대한 서비스 하
								럭셔리 고풍스러운호텔로서의 명성을 이어가고 있는 더 힐
								하우스 호텔은 그 시설뿐만 아니라 고객에 대한 서비스 하
							</div>

							{/* 더보기 접기 */}
							<div className="flex-justify_center mt_30">
								<div className={styles.more} onClick={moreOpen}>더보기 <i className={`${styles.arrow} ${toggleButton ? styles.active : ""}`} /></div>
							</div>
						</div>
					</div>
				</div>
			</div>


			<div className="flex-shrink_0 padding">
				<div className={styles["guide-bottom"]}>한국관광공사에서 받아오는 정보입니다.</div>
			</div>
		</div>
	)
}

export default TravelDetail8